import React, { useEffect, useState } from 'react'
import { Modal, Button, Badge } from 'react-bootstrap'
import { fetchAdminUsers, updateAdminUser, deleteUser } from '../utils/api'

export default function ManageUsersModal({ show, onHide }) {
  const [users, setUsers]     = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError]     = useState(null)

  // load all users when modal opens
  useEffect(() => {
    if (!show) return
    setLoading(true)
    setError(null)

    fetchAdminUsers()
      .then(fetched => setUsers(fetched))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false))
  }, [show])

  // handler to toggle active status
  const onToggle = async user => {
    try {
      const updated = await updateAdminUser(user.id, { active: !user.active })
      setUsers(list => list.map(u => (u.id === updated.id ? updated : u)))
    } catch (e) {
      alert('Could not update user: ' + e.message)
    }
  }

  const onRemove = async (user) => {
    if (!window.confirm(`Are you sure you want to delete ${user.email}?`)) {
      return;
    }
    try {
      await deleteUser(user.id);
      setUsers(list => list.filter(u => u.id !== user.id));
    } catch (e) {
      alert("Could not delete user: " + e.message);
    }
  };

  // filter out admin accounts
  const nonAdminUsers = users.filter(u => u.role !== 'admin')

  return (
    <Modal className="manage-users-modal"show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="manage-users-modal_title">Manage Users</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <p className="manage-users-modal_loading">Loading users…</p>
        ) : error ? (
          <p className="manage-users-modal_error text-danger">Error: {error}</p>
        ) : nonAdminUsers.length === 0 ? (
          <p className="manage-users-modal_empty">No users found.</p>
        ) : (
          <ul className="manage-users-modal_list list-group">
            {nonAdminUsers.map(u => (
              <li
                key={u.id}
                className="manage-users-modal_item list-group-item d-flex justify-content-between align-items-center">
                <button 
                  className="btn btn-sm btn-outline-secondary me-2"
                  onClick={() => onRemove (u)}
                >
                  x
                </button>
                <span className="manage-users-modal_email">{u.email}</span>
                <div className="manage-users-modal_actions">
                  <Badge bg={u.active ? 'success' : 'danger'} className="manage-users-modal_status-badge me-3">
                    {u.active ? 'Active' : 'Inactive'}
                  </Badge>
                  <Button
                    className="manage-users-modal_toogle-btn"
                    size="sm"
                    variant={u.active ? 'outline-danger' : 'outline-success'}
                    onClick={() => onToggle(u)}
                  >
                    {u.active ? 'Deactivate' : 'Activate'}
                  </Button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className="manage-users-modal_close-btn" variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
